"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React from "react";
import { WaveLeaderboardDrop } from "./WaveLeaderboardDrop";
import { WaveLeaderboardEmptyState } from "./WaveLeaderboardEmptyState";
import { WaveLeaderboardLoading } from "./WaveLeaderboardLoading";
import { WaveLeaderboardLoadingBar } from "./WaveLeaderboardLoadingBar";
interface WaveLeaderboardDropsProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onCreateDrop: () => void;
}
export const WaveLeaderboardDrops: React.FC<WaveLeaderboardDropsProps> = t0 => {
  const $ = _c(31);
  const {
    wave,
    sort,
    onCreateDrop
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== sort || $[1] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort
    };
    $[0] = sort;
    $[1] = wave.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  let t2;
  if ($[3] !== fetchNextPage || $[4] !== hasNextPage || $[5] !== isFetching || $[6] !== isFetchingNextPage) {
    t2 = async () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        await fetchNextPage();
      }
    };
    $[3] = fetchNextPage;
    $[4] = hasNextPage;
    $[5] = isFetching;
    $[6] = isFetchingNextPage;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const intersectionElementRef = useIntersectionObserver(t2);
  let t3;
  if ($[8] !== pathname || $[9] !== router || $[10] !== searchParams) {
    t3 = drop => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[8] = pathname;
    $[9] = router;
    $[10] = searchParams;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onDropClick = t3;
  if (isFetching && drops.length === 0) {
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <WaveLeaderboardLoading />;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  if (drops.length === 0) {
    let t4;
    if ($[13] !== onCreateDrop || $[14] !== wave) {
      t4 = <WaveLeaderboardEmptyState onCreateDrop={onCreateDrop} wave={wave} />;
      $[13] = onCreateDrop;
      $[14] = wave;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    return t4;
  }
  let t4;
  if ($[16] !== drops || $[17] !== onDropClick || $[18] !== wave) {
    let t5;
    if ($[20] !== onDropClick || $[21] !== wave) {
      t5 = drop_0 => <WaveLeaderboardDrop key={drop_0.id} drop={drop_0} wave={wave} onDropClick={onDropClick} />;
      $[20] = onDropClick;
      $[21] = wave;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    t4 = drops.map(t5);
    $[16] = drops;
    $[17] = onDropClick;
    $[18] = wave;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[23] !== isFetchingNextPage) {
    t5 = isFetchingNextPage && <WaveLeaderboardLoadingBar />;
    $[23] = isFetchingNextPage;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== intersectionElementRef) {
    t6 = <div ref={intersectionElementRef} />;
    $[25] = intersectionElementRef;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
    t7 = <div className="tw-space-y-4">{t4}{t5}{t6}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
};